export const apiItems = [
  {
    src: 'clipboard',
    label: 'Claims',
    subCategory: [
      {
        title: 'Claims API',
        route: 'all-apis',
        description:
          'Get summary and detailed claim status and payments, coordination of benefits, submit reconsiderations and appeals with attachments, and retrieve documents.',
      },
      {
        title: 'Claim Status (276/277) Extended X12 API',
        route: 'all-apis',
        description:
          'Inquire about the status of a claim or respond to a request inquiry.',
      },
    ],
  },
  {
    src: 'tooth',
    label: 'Dental',
    subCategory: [
      {
        title: 'Dental API',
        route: 'all-apis',
        description:
          'Our Dental APIs provide essential insights into patient coverage and real-time updates on claims, enhancing provider workflows and member interactions.',
      },
    ],
  },
  {
    src: 'id_card',
    label: 'Eligibility',
    subCategory: [
      {
        title: 'Eligibility API',
        route: 'all-apis',
        description:
          'Find quick access to primary care provider (PCP) details, plan coverage, benefit details and your members ID cards.',
      },
      {
        title: 'Eligibility (Lightweight) API',
        route: 'all-apis',
        description:
          'Get to eligibility information such as including demographics, coverage attributes and basic member information.',
      },
      {
        title: 'Eligibility and Benefits (270/271) Extended X12 API',
        route: 'all-apis',
        description:
          'Use the Eligibility and Benefit Inquiry (270) transaction to inquire about the health care eligibility and benefits associated with a subscriber or dependent.',
      },
    ],
  },
  {
    src: 'clipboard_checked',
    label: 'Prior Authorizations',
    subCategory: [
      {
        title: 'Prior Authorizations API',
        route: 'all-apis',
        description: 'Search and review prior authorization status details.',
      },
    ],
  },
  {
    src: 'mobile_clinic',
    label: 'Provider Demographic',
    subCategory: [
      {
        title: 'Provider Demographic API',
        route: 'all-apis',
        description:
          'Update provider demographics (add, terminate, change) directly from a practice management system or any application using HL7 FHIR format.',
      },
    ],
  },
  {
    src: 'chat',
    label: 'Referrals',
    subCategory: [
      {
        title: 'Referrals API',
        route: 'all-apis',
        description:
          'The Referrals API provides detailed information about previous referrals and referral submissions.',
      },
    ],
  },
  {
    src: 'share',
    label: 'Super Connector',
    subCategory: [
      {
        title: 'Super Connector API',
        route: 'all-apis',
        description:
          "Simplify your workflow with Super Connector, which seamlessly integrates APIs into providers' workflows, enhancing efficiency and improving user experience. Tailored API solutions streamline processes, reduce complexities, and optimize integration for all stakeholders, ensuring a smooth and efficient experience for all users.",
      },
    ],
  },
  {
    src: 'cursor',
    label: 'TrackIt',
    subCategory: [
      {
        title: 'TrackIt API',
        route: 'all-apis',
        description:
          'These APIs are designed to facilitate efficient tracking and management of action and notifications.',
      },
    ],
  },
];
